import { render, staticRenderFns } from "./createDocumentDialog.vue?vue&type=template&id=74c11c7c&"
import script from "./createDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./createDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports